import { useQuery } from "@tanstack/react-query";

import { api } from "../api/rest";
import type { CexDepthResponse } from "../api/types";

/**
 * Плотность стакана биржи расчёта.
 *
 * Опрос REST, а не сокет, по той же причине, что у счётчика ленты: это
 * СОСТОЯНИЕ, а не поток, где важен порядок. Заводить ради него тип сообщения в
 * раздаче значило бы трогать контракт, чтобы показать прибор.
 *
 * Считать перекос и стену в браузере нельзя, и это главная причина, по которой
 * они считаются на сервере: фону стены нужны шестьдесят секунд ряда, размаху —
 * триста. Вкладка, открытая минуту назад, посчитала бы фон по своей истории
 * опроса, то есть у каждой вкладки был бы свой порог. То же правило, по
 * которому серверным сделан счётчик ленты.
 */
export function cexDepthKey() {
  return ["cex-depth"] as const;
}

/**
 * Раз в три секунды.
 *
 * Не раз в секунду, хотя ряд секундный: сборщик сбрасывает пачку в базу раз в
 * пять секунд (`flushEvery`), и более частый опрос читал бы одно и то же,
 * заплатив за это тремястами строк на запрос.
 */
const POLL_MS = 3000;

export function useCexDepth() {
  return useQuery<CexDepthResponse>({
    queryKey: cexDepthKey(),
    queryFn: api.cexDepth,
    refetchInterval: POLL_MS,
    // В фоновой вкладке не опрашиваем: панель существует для наблюдения
    // глазами, и триста строк на символ для окна, на которое никто не смотрит,
    // — круг ни за чем.
    refetchIntervalInBackground: false,
  });
}
